module.exports = __webpack_public_path__ + "img/Slice2-min.a841a5c6.png";